export { default } from './Color';
